import { AGENT_CHAT_MAX_FILE_MB } from "./agentChatAttachmentLimits";

export const AGENT_CHAT_FILE_TOO_LARGE_MESSAGE = `File too large — max ${AGENT_CHAT_MAX_FILE_MB}MB`;
export const AGENT_CHAT_UNSUPPORTED_FILE_TYPE_MESSAGE =
    "This file type isn't supported";

export interface AgentChatComposerAttachmentErrorState {
    localId: string;
    status: "uploading" | "ready" | "error";
    error?: string;
}

export function getVisibleAttachmentError(
    attachments: readonly AgentChatComposerAttachmentErrorState[],
): string | null {
    return (
        attachments.find(
            (attachment) =>
                attachment.status === "error" && Boolean(attachment.error),
        )?.error ?? null
    );
}
